module.exports = __webpack_public_path__ + "img/hic-congenital-and-perinatal-diseases-female.34d926fd.png";